<template>
  <div
    v-if="isShowComponent"
    class="energy-container"
    :class="containerClasses"
  >
    <lazy-img
      v-if="lazyLoad"
      class="energy-label-button img-fluid"
      :image-url="parsedImageUrl"
      :alt="parsedImageAlt"
      :title="parsedImageAlt"
      @click="handleClick()"
    />
    <img
      v-else
      class="energy-label-button img-fluid"
      :src="parsedImageUrl"
      :alt="parsedImageAlt"
      :title="parsedImageAlt"
      loading="lazy"
      @click="handleClick()"
    >
  </div>
</template>

<script>
import { elParseTemplatedExpression } from '../helper/parser';

export default {

  inject: {
    itemId: {
      default: null
    }
  },
  props: {
    lazyLoad: {
      type: Boolean,
      default: false
    },
    containerClass: {
      type: String,
      default: ''
    },
    itemData: [String, Object],
    itemDataObj: { type: Object },
    freeFields: [Object],
    variationId: {
      type: Number,
      default: 0
    }
  },

  computed: {
    computedItemData () {
      if (this.itemData === 'categoryItem') {
        if (this.$parent && this.$parent.item) {
          return { ...this.$parent.item, ...{ freeFields: this.freeFields } };
        }

        if (this.itemDataObj && this.itemDataObj.item && this.itemDataObj.item.id) {
          return { ...this.itemDataObj, ...{ freeFields: this.freeFields } };
        }

        if (this.variationId) {
          const lastSeenItem = this.$store.state.lastSeen.lastSeenItems.find(itemDat => itemDat.id === this.variationId);
          return lastSeenItem ? { ...lastSeenItem.data, ...{ freeFields: this.freeFields } } : {};
        }
      } else if (this.itemData === 'basketItem') {
        if (this.$parent && this.$parent.basketItem) {
          const variationData = JSON.parse(JSON.stringify(this.$parent.basketItem.variation.data));

          variationData.variationProperties = variationData.fullVariationProperties;

          if (EnergyLabelConfig.basketFreeFields.length > 0) {
            const freeF = EnergyLabelConfig.basketFreeFields.find(itemDat => itemDat.id === variationData.item.id);

            return { ...variationData, ...{ freeFields: freeF } };
          } else {
            return variationData;
          }
        }
      } else if (this.itemData === 'singleItem') {
        return this.$store.getters[`${this.itemId}/currentItemVariation`];
      }
      return this.itemData;
    },

    currentGroup () {
      let result = 'unknown-group';

      for (const [key, value] of Object.entries(EnergyLabelConfig.groupCriteries)) {
        const val = this.parseTemplatedExpression(value, true);

        if (val && val !== '0') {
          result = key;
          break;
        }
      }
      return result;
    },

    containerClasses () {
      const classes = {};

      this.containerClass.split(' ').forEach((item) => {
        if (item.length > 0) {
          classes[item] = true;
        }
      });
      return classes;
    },

    isUseLowercase () {
      if (EnergyLabelConfig.global.useLowercase === true || EnergyLabelConfig.global.useLowercase == 'true') {
        return true;
      }
      return false;
    },

    parsedImageUrl () {
      const labelImageUrl = EnergyLabelConfig.settings[this.currentGroup] ? EnergyLabelConfig.settings[this.currentGroup]['label-img'] : '';

      return this.parseTemplatedExpression(labelImageUrl, true);
    },

    parsedImageAlt () {
      const labelImageAlt = EnergyLabelConfig.settings[this.currentGroup] ? EnergyLabelConfig.settings[this.currentGroup]['label-img-alt'] : '';
      const labelImageAltParsed = this.parseTemplatedExpression(labelImageAlt, true);

      let labelImageAltBasic = (this.parsedImageUrl || '').split('/').pop();
      labelImageAltBasic = labelImageAltBasic.substring(0, labelImageAltBasic.lastIndexOf('.')) || labelImageAltBasic;

      return labelImageAltParsed && labelImageAltParsed.length > 0 ? labelImageAltParsed : labelImageAltBasic;
    },

    isShowComponent () {
      return this.parsedImageUrl && this.parsedImageUrl.length > 0;
    }
  },

  methods: {
    handleClick () {
      if (!this.$isSSR) {
        const energyLabelModal = $('#energyLabelModal');
        let fieldsHtml = '';

        if (energyLabelModal.length > 0 && EnergyLabelConfig.settings[this.currentGroup]) {
          let group = this.currentGroup;

          group = (group === 'lamp') ? '' : `${group}-`;

          const energyFields = EnergyLabelConfig.settings[this.currentGroup].fields;

          Object.keys(energyFields).forEach((key) => {
            const val = decodeURIComponent(this.parseTemplatedExpression(energyFields[key])) || '';

            if (val) {
              fieldsHtml += `<span class="${group}${key}">${val}</span>`;
            }
          });
        }

        energyLabelModal.find('.detailed-energy-image').attr('src', this.parsedDetailImageUrl());
        energyLabelModal.find('.energy-fields-list').html(fieldsHtml);
        energyLabelModal.find('.content-bl').attr('data-class', this.parsedDetailClass());
        energyLabelModal.modal('show');
      }
    },

    parsedDetailImageUrl () {
      const detailImageUrl = EnergyLabelConfig.settings[this.currentGroup] ? EnergyLabelConfig.settings[this.currentGroup]['detail-img'] : '';

      return this.parseTemplatedExpression(detailImageUrl, true);
    },

    parsedDetailClass () {
      const detailClass = EnergyLabelConfig.settings[this.currentGroup] ? EnergyLabelConfig.settings[this.currentGroup]['detail-class'] : '';

      return this.parseTemplatedExpression(detailClass);
    },

    parseTemplatedExpression (text, emptyWipe = false) {
      return elParseTemplatedExpression(text, this.computedItemData, this.isUseLowercase, emptyWipe);
    }
  }
};
</script>
